module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-regular.ea6f280f.ttf";